import { render, staticRenderFns } from "./UiColorFilter.vue?vue&type=template&id=059e7076"
import script from "./UiColorFilter.vue?vue&type=script&lang=js"
export * from "./UiColorFilter.vue?vue&type=script&lang=js"
import style0 from "./UiColorFilter.vue?vue&type=style&index=0&id=059e7076&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports